module.exports = "mutation {\n    setIsUserFromTarget\n}"